/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgConveyorBelt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M17.707 8.293 21.414 12l-3.707 3.707-1.414-1.414L18.586 12l-2.293-2.293zM8 9v6H2V9zm7 0v6H9V9zm-9 2H4v2h2zm7 0h-2v2h2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgConveyorBelt as ConveyorBelt };
